<template>
  <t-form labelWidth="100px">
    <t-form-item label="显示行数">
      <t-input-number v-model="attribute.showLine" size="small" :min="1" :max="200" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="字体">
      <t-input-number v-model="attribute.fontSize" size="small" :min="12" :max="200" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="颜色">
      <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.color" size="small"/>
    </t-form-item>
  </t-form>
</template>

<script setup>
const props = defineProps({
  attribute:Object
})
</script>

<style scoped>

</style>